<script setup>

import MultiBooking from "@/components/bookings/MultiBooking"
import Notification from "@/classes/component-classes/Notification";
import FreightBooking from "@/classes/viewmodels/FreightBooking";
import CourierBooking from "@/classes/viewmodels/CourierBooking";
import API from "@/classes/global/API";

import {useGetDropDownValue} from "@/composables/common/useGetDropDownValue";
import {useRoute, useRouter} from "vue-router";
const router = useRouter();

import {inject, onMounted, computed, ref} from 'vue';
import store from "@/store";
import ContactDetail from "@/classes/bookings/ContactDetail";

const freightBooking = inject("freightBooking");
const courierBooking = inject("courierBooking");

let editFreightBooking = ref(new FreightBooking());
let editCourierBooking = ref(new CourierBooking());

const route = useRoute();

const freightBookingModel = computed({

  get() {

    if (route.params.section === 'freightBooking' && route.params.id === 'new') {
      return freightBooking.value
    }
    return editFreightBooking.value
  },

  set(value) {

    // New freight booking sent from multibooking update:modelValue
    freightBooking.value = value;
  }

})

const courierBookingModel = computed({

  get() {

    if (route.params.section === 'courierBooking' && route.params.id === 'new') {
      return courierBooking.value
    }
    return editCourierBooking.value
  },

  set(value) {
    courierBooking.value = value;
  }

})

onMounted(() => {

  if (route.params.id !== 'new') {

    // Must be edit, get the record to display
    editCompanyDetail();
  }

})

async function editCompanyDetail() {

  const companyDetail = await API.getCompanyToEdit(route, route.params.section) ?? null;

  if(companyDetail) {

    if(!companyDetail.isEditable) return router.push({name: 'jobNotEditableUserInfo' });

    companyDetail.hasOwnProperty('consignment') ? mapEditBooking(companyDetail, editCourierBooking) :
    mapEditBooking(companyDetail, editFreightBooking);
  }

}

async function mapEditBooking(data, section) {

  section.value = {...section.value, ...data};

  // Add these back in the view model
  section.value.shipper.shipperContacts = [];
  section.value.consignee.consigneeContacts = [];

  section.value.isUpdate.shipper = true;
  section.value.isUpdate.consignee = true;

  if(section.value.hasOwnProperty('shipment')) {
    section.value.shipment.shipmentInsuranceAmount ? section.value.shipment.shipmentInsurance = true :
        section.value.shipment.shipmentInsurance = false;
  }

  section.value.dimensions.unitOfMeasure === 'imperial' ? section.value.unitOfMeasureSwitch = true :
      section.value.unitOfMeasureSwitch = false;

  delete section.value.dimensions.unitOfMeasure;

  // Remove properties from model for courier edit where terms and insurance are not editable, to stop validation trigger
  if(section.value.hasOwnProperty('consignment')) delete section.value.consignment.termsOfShipment;

  const shipper = await API.getCompanyDetail(section.value.shipper.id, route) ?? null;

  if (shipper) {

    shipper.contacts?.forEach(item => {
      section.value.shipper.shipperContacts.push(item)
    });

    let shipperContact = section.value.shipper.shipperContacts.find(c =>

        c.firstName === section.value.shipper.shipperContactFirstName &&
        c.lastName === section.value.shipper.shipperContactLastName &&
        c.title === section.value.shipper.shipperContactTitle &&
        c.email === section.value.shipper.shipperContactEmail &&
        c.phone === section.value.shipper.shipperContactPhone &&
        c.value === section.value.shipper.shipperContactFullName
    ) ?? null;

    if(!shipperContact) {
      section.value.shipper.shipperContactFullName = '';

    } else {

      section.value.shipper.shipperContactId = shipperContact.id;
      section.value.shipper.shipperContactDepartment = shipperContact.department
    }

  }

  const consignee = await API.getCompanyDetail(section.value.consignee.id, route);

  if(consignee) {

    consignee.contacts?.forEach(item => {
      section.value.consignee.consigneeContacts.push(item);
    });

    let consigneeContact = section.value.consignee.consigneeContacts.find(c =>

        c.firstName === section.value.consignee.consigneeContactFirstName &&
        c.lastName === section.value.consignee.consigneeContactLastName &&
        c.title === section.value.consignee.consigneeContactTitle &&
        c.email === section.value.consignee.consigneeContactEmail &&
        c.phone === section.value.consignee.consigneeContactPhone &&
        c.value === section.value.consignee.consigneeContactFullName
    ) ?? null;


    if (!consigneeContact) {
      section.value.consignee.consigneeContactFullName = '';

    } else {

      section.value.consignee.consigneeContactId = consigneeContact.id;
      section.value.consignee.consigneeContactDepartment = consigneeContact.department;

    }

  }

}

</script>

<template class="view-booking">
  <div v-if="route.params.section ==='freightBooking'">
    <MultiBooking
        :key="route.params.id"
        validationViewModelSection="freightBooking"
        v-model="freightBookingModel">
    </MultiBooking>
  </div>
  <div v-if="route.params.section ==='courierBooking'">
    <MultiBooking
        :key="route.params.id"
        tileColor="#3f7da2"
        validationViewModelSection="courierBooking"
        v-model="courierBookingModel">
    </MultiBooking>
  </div>
</template>


